import { createModel, createSelector } from "nyax";
import { Robot } from "src/models/robot";
import { createItemsEntityModel } from "src/store/itemsEntity";

export const RobotEntityModel = createModel(
  class extends createItemsEntityModel<Robot>((item) => item.id) {
    public selectors() {
      return {
        ...super.selectors(),

        robots: createSelector(
          (): Robot[] => this.getters.items,
          (items) => items
        ),
      };
    }
  }
);
